import React, { useEffect, useState, useContext } from "react";
import { CurrentUserContext } from "../../context/CurrentUserContext";
import { Link } from 'react-router-dom';
import { slugToText } from "../../utils/slugify";
import './MyNotes.css';
import DeleteNotePopup from "./DeleteNotePopup";
import { useTranslation } from "../../utils/hooks/translateHook";

export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL

console.log("Fetching notes from:", `${API_URL}/notes`);

const MyNotes = () => {
  const { currentUser, notesUpdated, setNotesUpdated } = useContext(CurrentUserContext);
  const [ notes, setNotes ] = useState([]);
  const [ openNoteId, setOpenNoteId] = useState(null);
  const [ noteToDelete, setNoteToDelete ] = useState(null);
  const [isDeletePopupOpen, setIsDeletePopupOpen ] = useState(false);

  const t = useTranslation();

  const fetchNotes = () => {
    fetch(`${API_URL}/notes?_=${Date.now()}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`}
    })
    .then(res => res.json())
    .then(data => {
      const sorted =data.sort((a,b) => {
      const parse = (slug) => {if (!slug) return [0, 0, 0];
      const nums = slug.split('-').map(n => Number(n));
      return nums.length >= 3 ? nums.slice(0, 3) : [0, 0, 0];
      };

      const [a1, a2, a3] = parse(a.videoSlug);
      const [b1, b2, b3] = parse(b.videoSlug);
      return a1 - b1 || a2 - b2 || a3 - b3
      });
      setNotes(sorted);
    });
  };

  useEffect(() => {
    if (!currentUser?._id) return;  
    fetchNotes();
  }, [currentUser, notesUpdated])

  const handleDeleteNote = (note) => {
    fetch(`${API_URL}/notes/${note.videoSlug}?_=${Date.now()}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then((res) => {
      if (!res.ok) throw new Error('Failed to delete');
      fetchNotes();
      setNotesUpdated(prev => prev + 1);
      setIsDeletePopupOpen(false);
    })
    .catch((err) => {
      alert('Error deleting note');
      console.error(err);
    });
  }


  const downloadNote = (slug, content) => {
    const element = document.createElement("a");
    const file = new Blob([content], { type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = `${slugToText(slug)}.text`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="notes-list">
      <div className="notes-frame">
        <h2>{t('notes')} </h2>
      {notes.length === 0 && <p>{t('noNotes')}</p>}
        <ul>
          {notes.map((note) => (
            <li key={note._id} className="note-item">
              <div className="note-header">
                <Link to={`/videos/${note.videoSlug}`} className="note-title">
                  {slugToText(note.videoSlug).replace(/^(\d+)\s(\d+)\s(\d+)/, '$1.$2.$3')}
                </Link>
                <div className="note-actions">
                  <button 
                    className="download-icon" 
                    onClick ={() => downloadNote(note.videoSlug, note.content)}
                    title="Download Note" >
                  </button>
                  <div className="buttons-bundle">
                    <button className="view-icon" 
                    onClick={() => setOpenNoteId(openNoteId === note._id ? null : note._id )}
                    title={openNoteId === note._id ? "Hide Note" : "View Note"} >
                    {t('viewNotes')}
                  </button>
                  <button className="delete-button" 
                    onClick={() => { 
                      setNoteToDelete(note);
                      setIsDeletePopupOpen(true);
                    }}
                  >
                    {t('deleteNotes')}
                  </button>
                  </div>
                  { openNoteId === note._id && (
                    <pre className="note-content">{note.content}</pre>
                  )} 
                </div> 
              </div>
            </li>
          ))}
        </ul>
        {/*popup*/}
        <DeleteNotePopup
          isOpen={isDeletePopupOpen}
          onClose={() => setIsDeletePopupOpen(false)}
          onDelete={handleDeleteNote}
          note={noteToDelete}
        />

      </div>
    </div>
  );
};

export default MyNotes;
